import { useEffect, useRef, useState } from 'react';

export const useInterval = (callback: (...args: any[]) => void, delay: number) => {
  const [isOperating, setIsOperating] = useState<boolean>(false);
  const [id, setId] = useState<number>(null);

  const savedCallback = useRef(null);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function handler() {
      savedCallback.current();
    }

    if (isOperating && !id) {
      const intervalId = window.setInterval(handler, delay);
      setId(intervalId);
      return () => clearInterval(intervalId);
    }
  }, [isOperating]);

  useEffect(() => {
    if (!isOperating) {
      clearInterval(id);
      setId(null);
    }
  }, [isOperating]);

  function start() {
    setIsOperating(true);
  }

  function stop() {
    setIsOperating(false);
  }

  return {
    isOperating,
    start,
    stop,
  };
};

export default useInterval;
